import { render, staticRenderFns } from "./InstructorDetailModal.vue?vue&type=template&id=f2c55d86&scoped=true"
import script from "./InstructorDetailModal.vue?vue&type=script&lang=js"
export * from "./InstructorDetailModal.vue?vue&type=script&lang=js"
import style0 from "./InstructorDetailModal.vue?vue&type=style&index=0&id=f2c55d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c55d86",
  null
  
)

export default component.exports